import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { List } from 'antd';



class ChildMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidMount() {

	}

	async componentDidUpdate() {

	}


	render() {
		const { menu } = this.props;
		let data = [];
		switch (menu) {
			case 'Getting Started':
				data = [
					{
						title : "Getting Started with Craffview",
						description : "Before diving into Craffview, it's important to understand its objectives and how you can benefit from its features. This collection of articles will assist you in navigating the platform and making the most of its offers."
					},
					{
						title : "What is Craffview?",
						description : "Craffview is a marketing platform or service designed to track user data, facilitate acquisition campaigns for businesses. Its primary focus is on helping businesses plan, execute, and track marketing campaigns aimed at acquiring new customers. The platform provides various tools and features to simplify the process of reaching potential customers and converting them into paying customers. These tools encompass a wide range of functionalities, including email marketing, social media advertising, search engine marketing, content marketing, and more. Common features found in an acquisition campaign marketing platform like Craffview include audience targeting, campaign creation and management, advertising capabilities, tracking and analytics, automation and personalization, integration with other marketing tools, and A/B testing."
					}
				];
				break;
			case 'Craffview Overview':
				data = [
					{
						title : "Craffview Overview",
						description : "Welcome to Craffview. To get started, we focus on the implementation of Craffview, which requires some preparation before we can optimize the value to your company. Please refer to our integration guide with technical details."
					},
					{
						title : "How Craffview Works",
						description : "Craffview is a comprehensive marketing platform that assists brands in tracking, creating, and targeting campaigns across multiple channels. One of its notable capabilities is the ability to track data from mobile, web, and TV applications, which can be utilized in campaigns and other marketing activities. By capturing and analyzing data from these sources, Craffview empowers brands to make informed decisions and optimize their marketing strategies for better results."
					}
				];
				break;
			case 'Users':
				data = [
					{
						title : "Users",
						description : "In Craffview, audience information is stored in user profiles, which are comprehensive collections of information and attributes that describe individual consumers. These user profiles contain the following attributes:"
					},
					{	
						description : "User ID: Each user profile is uniquely identified by a user ID. This allows for accurate tracking and management of user data."
					},
					{	
						description : "Subscription Status: This attribute captures information about the user's subscription status, including their plan, business unit (BU), subscription period, payment method, and other relevant details. Understanding this information is crucial for gaining insights into user habits and preferences."
					},
					{	
						description : "Events: Craffview tracks and records every action taken by the user, such as watching a movie, clicking a banner, or opening an app. These events provide valuable data for analyzing user behavior and engagement patterns."
					},
					{	
						description : "Device: This attribute lists the devices that the user has used to interact with the brand. It may include mobile devices, web browsers, set-top boxes, and smart TVs. Knowing the devices used by users helps optimize marketing strategies for specific platforms and devices."
					},
					{	
						description : "By capturing and organizing these attributes within user profiles, Craffview enables businesses to better understand their audience and tailor their marketing efforts to effectively engage and convert users."
					}
				];
				break;
			case 'Integration':
				data = [
					{
						title : "Integration",
						description : (<>Integrating with Craffview may require some technical skills. We will guide you step by step through the process, and our technical support team will assist you in resolving any technical planning, issues, and testing concerns alongside your developers.<br /><br />To begin using Craffview, follow these simple steps:</>)
					},
					{
						title : "Step 1: SDK Installation",
						description : "The Craffview SDK (Software Development Kit) is the means by which we send and receive information to and from your app or website. To proceed, you will need an API Key and SDK Endpoint, both of which will be provided by our account manager."
					},
					{
						title : "Step 2: Familiarize Yourself with Our Attributes",
						description : "Craffview offers numerous attributes and events that allow you to gain insights into how well your content is being viewed and understand customer behavior within your app. By comprehending the meaning of these attributes, you can integrate them into your app and website in order to track the desired data and optimize your marketing promotions and campaigns."
					},
					{
						title : "Step 3: Verify the Connection",
						description : "Once you have completed the SDK installation and incorporated the necessary variables into your code, you can trigger events within your app or website to verify whether the data is being successfully sent to the endpoint."
					},
					{
						title : "Step 4: Plan Implementation",
						description : "Now it's time to plan what you want to track in Craffview and gain insights into customer engagement that will enhance your marketing strategies once the integration is complete."
					},
					
				];
				break;
			case 'Logging into Craffview':
				data = [
					{
						title : "Accessing Craffview Login",
						description : "If you are a first-time user and need to log into the system, you will receive a welcome email from our account manager containing your login credentials."
					},
					{
						description : "Once you have successfully logged into the system, locate the top right corner and click on your company profile. This will allow you to access the user management area, where you can add new users and define their roles and statuses."
					},
					
				];
				break;
			case 'Managing Account':
				data = [
					{
						title : "Account Management in Craffview",
						description : (<>In Craffview, the role permissions feature empowers you to control access to specific features within the dashboard. You can assign either admin or limited permissions to determine who can utilize these features. The first admin of the account will be designated as the default administrator with full access. <br /><br />Here are the roles and their corresponding permissions:</>)
					},
					{
						description : (<><b>Admin:</b> Administrators possess unrestricted access to all available features in Craffview.</>)
					},
					{
						description : (<><b>Editor:</b> Editors have the ability to create, modify, and delete content but do not have access to user management or billing functionalities.</>)
					},
					{
						description : (<><b>Viewer:</b> Viewers are limited to viewing and downloading reports only. They do not have access to user management or billing features.</>)
					},
					{
						description : "By assigning these roles, you can tailor access privileges to suit the needs and responsibilities of different users within your Craffview account."
					},
					
				];
				break;
			case 'Setting':
				data = [
					{
						title : "Settings",
						description : "Basic Settings on top menu bar."
					},
					{
						description : (<><b>Period:</b> In the Period setting, users can select a date range for data analysis. By default, the system displays data from the last 7 days starting from the current date. However, users have the flexibility to choose the last 31 days of data until a specified date range. This allows for customized analysis based on specific timeframes.</>)
					},
					{
						description : (<><b>Display Mode:</b> The Display Mode feature allows users to personalize their viewing experience by selecting either a light or dark mode as their preferred background. This option enhances user comfort and improves readability based on individual preferences.</>)
					},
					{
						description : (<><b>Data Mode:</b> The Data Mode setting provides users with the ability to choose between two options: sandbox and production. The sandbox mode is designed for testing purposes and allows users to experiment with data without affecting live records. On the other hand, the production mode provides access to live data records, enabling users to analyze real-time information.</>)
					},
					{
						description : "By adjusting these basic settings, users can optimize their experience within the Craffview platform and tailor it to their specific needs and preferences."
					},
					
				];
				break;
			default:
		}
		
		
		return (
			<List
				itemLayout="horizontal"
				dataSource={data}
				renderItem={(item, index) => (
				<List.Item>
					<List.Item.Meta
					title={item.title}
					description={item.description}
					/>
      			</List.Item>
				)}
			/>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(ChildMenu);
